'use client';

import React from 'react';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import classNames from 'classnames';
import { ChevronDownIcon } from '@heroicons/react/24/solid';

export default function AccordionItem({ heading, panel, defaultOpen }) {
	return (
		<Disclosure as="li" className="mt-2" defaultOpen={defaultOpen}>
			{({ open }) => (
				<>
					<DisclosureButton
						className="flex gap-x-8 w-full justify-between rounded-lg px-4 py-2 text-left focus:outline-none focus-visible:ring"
					>
						{heading}
						<ChevronDownIcon
							className={classNames({ 'rotate-180 transform': open }, 'h-5 w-5 font-semibold')}
						/>
					</DisclosureButton>
					<DisclosurePanel static className={classNames('px-4 pb-2 pt-4 text-left', { hidden: !open })}>
						{panel}
					</DisclosurePanel>
				</>
			)}
		</Disclosure>
	);
}
